import { apiGetPropertyAssetsCollection } from "./propertyAssets";

export const PROPERTY_COLLECTION_KEYS = {
  PROPERTY_ASSETS: "propertyAssets",
};

export const PROPERTY_COLLECTIONS = {
  [PROPERTY_COLLECTION_KEYS.PROPERTY_ASSETS]: {
    key: PROPERTY_COLLECTION_KEYS.PROPERTY_ASSETS,
    title: "Properties",
    description: "Property collection",
    fetch: apiGetPropertyAssetsCollection,
    defaultPagination: { page: 1, limit: 25 },
    defaultOrdering: { field: "updatedAt", order: "Desc" },
  },
};

export const resolvePropertyCollection = (key) =>
  PROPERTY_COLLECTIONS[key] ||
  PROPERTY_COLLECTIONS[PROPERTY_COLLECTION_KEYS.PROPERTY_ASSETS];

